import { render, staticRenderFns } from "./noticedetail.vue?vue&type=template&id=239b19a3&scoped=true&"
import script from "./noticedetail.vue?vue&type=script&lang=js&"
export * from "./noticedetail.vue?vue&type=script&lang=js&"
import style0 from "./noticedetail.vue?vue&type=style&index=0&id=239b19a3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239b19a3",
  null
  
)

export default component.exports